import { of, EMPTY } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import { LOCATION_CHANGE } from "connected-react-router";
import * as getters from "../../getters";
import * as actions from "../../actions";

export const tenantChange = (actionStream, state$) =>
  actionStream.pipe(
    ofType(LOCATION_CHANGE),
    mergeMap(({ payload }) => {
      const state = state$.value;
      const existingCountyId = getters.county(state);

      const {
        location: { pathname },
      } = payload;

      const id = pathname.split("/")[1] || null;
      const hasTenantId = id !== null && id !== "signin";

      if (!hasTenantId) {
        return of(actions.county.set(null), actions.billingReport.reset());
      } else if (hasTenantId && id !== existingCountyId) {
        return of(actions.county.set(id), actions.billingReport.reset());
      }

      return EMPTY;
    })
  );

export default [tenantChange];
